var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-local-v-1-widget',{attrs:{"items":_vm.items,"columns":_vm.columns,"actions":_vm.actions,"loading":_vm.loading},on:{"clickView":function (row) { return _vm.$emit('clickView', row); }},scopedSlots:_vm._u([{key:"c1",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.image_datas.length)+" รูป")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }